import {
  Button,
  Pagination,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, {useState} from "react";
import MWSkeleton from "../../../components/MWSkeleton";
import SubTitle from "../../../components/SubTitle";
import {useGetQuery} from "../../../hooks/useQueryHooks";
import {myEvalTableHead} from "../../../models/clientModels/data/tableHeaderData";
import {ResponseList} from "../../../models/clientModels/interfaces/Response";

import {StyledTable} from "../../../styledComponents/StyledListContainer";

import {useNavigate} from "react-router-dom";
import {useRecoilValue} from "recoil";
import {tokenSelector, userState} from "../../../Recoil/Atom/authState";
import * as categoryListApi from "../../../api/educationApi/educationCategoryApi";
import * as myEvalApi from "../../../api/educationApi/myEvalApi";
import {
  EDCategory,
  initialEDCategoryListParams,
} from "../../../models/serverModels/education/EDCategory";
import {EDCurriculum} from "../../../models/serverModels/education/EDCurriculum";
import {PaginationContainer} from "../../../styledComponents/StyledPagination";

const MyEval = () => {
  const navigate = useNavigate();

  const tokenState = useRecoilValue(tokenSelector);
  const user = useRecoilValue(userState);

  const [page, setPage] = useState<number>(1);

  // region: Query (교육과정 카테고리 리스트)
  const {data: category} = useGetQuery<ResponseList<EDCategory>>({
    key: ["EducationCategoryListAll", {...initialEDCategoryListParams, token: tokenState, page}],
    api: () =>
      categoryListApi.getListAll({...initialEDCategoryListParams, token: tokenState, page}),
    options: {
      cacheTime: 0,
    },
  });

  const {
    data: myEval,
    isLoading,
    isFetching,
  } = useGetQuery<ResponseList<EDCurriculum>>({
    key: ["myEvalList", {id: user.uid, token: tokenState}],
    api: () => myEvalApi.getList({id: user.uid, token: tokenState}),
  });

  const paginationHandleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  return (
    <React.Fragment>
      <SubTitle subTitle="내 평가 목록" />
      <TableContainer component={Paper} sx={{backgroundColor: "#fff", marginTop: "16px"}}>
        <StyledTable>
          <TableHead style={{backgroundColor: "#f0fafa"}}>
            <TableRow>
              {myEvalTableHead.map((item, index) => (
                <TableCell key={index} align="center">
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading && isFetching ? (
              <MWSkeleton row={12} column={8} />
            ) : (
              myEval?.items.map((item) => {
                const depth1 = category?.items.find((id) => id.uid === item.category1UID);
                const depth2 = depth1?.subCategories.find((id) => id.uid === item.category2UID);
                const depth3 = depth2?.subCategories.find((id) => id.uid === item.category3UID);
                return (
                  <TableRow key={item.uid}>
                    <TableCell align="center">{`${item?.year}년 ${item?.month}월 1일 ~ ${
                      item.month === 12 ? 1 : item.month + 1
                    }월 1일`}</TableCell>
                    <TableCell align="center">{depth1?.name}</TableCell>
                    <TableCell align="center">{depth2?.name}</TableCell>
                    <TableCell align="center">{depth3?.name}</TableCell>
                    <TableCell align="center">
                      <Button
                        onClick={() => {
                          navigate(`/Education/StartExam/${item.uid}`, {
                            state: item.uid,
                          });
                        }}
                      >
                        응시하기
                      </Button>
                    </TableCell>
                    <TableCell align="center">{item.allScoreAverage}</TableCell>
                    <TableCell align="center">{item.allTrialCount}</TableCell>
                    <TableCell align="center">{}</TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </StyledTable>
      </TableContainer>

      {/* 페이지네이션 */}
      <PaginationContainer>
        <Pagination
          count={myEval?.maxPage}
          page={page}
          onChange={paginationHandleChange}
          variant="outlined"
          color="primary"
          shape="rounded"
        />
      </PaginationContainer>
    </React.Fragment>
  );
};

export default MyEval;
